import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { palette } from '@cbhq/cds-web/tokens';
import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import { LinkPressable } from '../../ui/Link/LinkPressable.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
const ICON_SIZE = '40';
const ITEM_MIN_WIDTH = 145;
function TrapdoorProductListColumn({
  iconUrl,
  header,
  subhead,
  url,
  target
}) {
  return /*#__PURE__*/jsx(LinkPressable, {
    href: url || '',
    "data-qa": ANALYTICS_KEY.TrapDoorProductListColumn,
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : undefined,
    children: /*#__PURE__*/jsxs(ItemWrapper, {
      title: header,
      tabIndex: 0,
      children: [iconUrl ? /*#__PURE__*/jsx(StyledIcon, {
        src: iconUrl,
        height: ICON_SIZE,
        width: ICON_SIZE,
        alt: header
      }) : /*#__PURE__*/jsx(Icon, {
        name: "caretRight",
        color: "foreground",
        size: "xs",
        spacingEnd: 2
      }), /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: 316,
        children: [/*#__PURE__*/jsx(Text, {
          variant: "headline",
          as: "h4",
          color: "foreground",
          children: header
        }), /*#__PURE__*/jsx(Text, {
          variant: "body",
          as: "p",
          color: "foregroundMuted",
          children: subhead
        })]
      })]
    }, header)
  });
}
const StyledIcon = styled.img`
  margin-right: 12px;
  filter: drop-shadow(0px 2px 2px rgba(91, 97, 110, 0.14))
    drop-shadow(0px 3px 1px rgba(91, 97, 110, 0.12))
    drop-shadow(0px 1px 5px rgba(91, 97, 110, 0.2));
`;
const ItemWrapper = styled.div`
  display: inline-flex;
  color: inherit;
  align-items: center;
  min-width: ${ITEM_MIN_WIDTH}px;
  cursor: pointer;
  &:hover {
    h4 {
      color: ${palette.primary};
    }
    p {
      color: ${palette.foreground};
    }
    div {
      color: ${palette.primary};
    }
  }
`;
export { ItemWrapper, TrapdoorProductListColumn };
//# sourceMappingURL=TrapdoorProductListColumn.js.map
